import { useNotification } from '@/composables/useNotification.js'
const { showNotification } = useNotification()

export function useFormatPhoneNumber(phoneNumber, countryCode, useLocalNumber = false) {
  const countryCodes = {
    AL: '+355',
    AD: '+376',
    AM: '+374',
    AT: '+43',
    AZ: '+994',
    BY: '+375',
    BE: '+32',
    BA: '+387',
    BG: '+359',
    HR: '+385',
    CY: '+357',
    CZ: '+420',
    DK: '+45',
    EE: '+372',
    FI: '+358',
    FR: '+33',
    GE: '+995',
    DE: '+49',
    GR: '+30',
    HU: '+36',
    IS: '+354',
    IE: '+353',
    IT: '+39',
    KZ: '+7',
    XK: '+383',
    LV: '+371',
    LI: '+423',
    LT: '+370',
    LU: '+352',
    MT: '+356',
    MD: '+373',
    MC: '+377',
    ME: '+382',
    NL: '+31',
    MK: '+389',
    NO: '+47',
    PL: '+48',
    PT: '+351',
    RO: '+40',
    RU: '+7',
    SM: '+378',
    RS: '+381',
    SK: '+421',
    SI: '+386',
    ES: '+34',
    SE: '+46',
    CH: '+41',
    TR: '+90',
    UA: '+380',
    US: '+1',
    GB: '+44',
    VA: '+379'
  }

  // todo remove workaround
  countryCode = countryCode?.split(',')[0]

  if (!countryCodes[countryCode]) {
    throw new Error('Invalid country code')
  }

  const countryPhoneCode = countryCodes[countryCode]
  if (phoneNumber.startsWith('0')) {
    phoneNumber = phoneNumber.replace(/^0/, countryPhoneCode + ' ')
  }

  if (useLocalNumber && phoneNumber.startsWith('+')) {
    phoneNumber = `0${phoneNumber.split(countryCodes[countryCode]).pop()}`
  }

  if (useLocalNumber) {
    return phoneNumber
  }

  const regex = /^\+[\d\s]{11,}$/
  if (regex.test(phoneNumber) && !useLocalNumber) {
    return phoneNumber
  } else {
    showNotification({
      message: 'Invalid phone number',
      variant: 'danger'
    })
  }
}
